import React from 'react';
import styled from 'styled-components';
import { layout, space } from 'styled-system';
const Component = styled.div `
  ${layout};
  ${space};

  box-sizing: content-box;
  margin-left: auto;
  margin-right: auto;

  ${({ hasChildrenCentered }) => hasChildrenCentered
    ? `align-items: center; display: flex; flex-direction: column;`
    : ''};

  ${({ hasTextCentered }) => (hasTextCentered ? 'text-align: center' : '')};
`;
export const Center = ({ htmlAttrs = {}, ...rest }) => (React.createElement(Component, { ...htmlAttrs, ...rest }));
Center.defaultProps = {
    hasChildrenCentered: false,
    hasTextCentered: false,
    maxWidth: '90rem',
    px: 'x0',
};
//# sourceMappingURL=index.js.map